import { Component } from '@angular/core';
import { RidButton } from '../../../components/rid-button/rid-button';
import { RidDemoPage } from '../../../components/rid-demo-page/rid-demo-page';

@Component({
  selector: 'app-syllabic-keyboard-plus-page',
  imports: [RidButton, RidDemoPage],
  templateUrl: './syllabic-keyboard-plus-page.html',
})
export class SyllabicKeyboardPlusPage {}
